import React from 'react'
import { FormContext, ContextProps } from './FormDuuf'

const useFormDuuf = () => {
  const context = React.useContext(FormContext)

  return context as ContextProps
}

export default useFormDuuf
